import React, { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import { colors, useMapColorScheme } from "@rubi/ui";
import {
  Map,
  MapCameraChangedEvent,
  MapMouseEvent,
  Marker,
  useApiIsLoaded,
} from "@vis.gl/react-google-maps";

import { ICameras, ICoordinates } from "@/types";

interface IPropertyCamerasMapProps {
  location: ICoordinates;
  values: ICameras;
  setFieldValue: any;
  errors: any;
  displayOnly?: boolean;
}

const PropertyCamerasMap: React.FC<IPropertyCamerasMapProps> = ({
  location,
  values,
  setFieldValue,
  errors,
  displayOnly = false,
}) => {
  const mapColorScheme = useMapColorScheme();
  const apiIsLoaded = useApiIsLoaded();

  // Controlled camera: the map has to follow `location` when the registrant
  // picks a different address, while leaving the zoom they set alone.
  const [camera, setCamera] = useState({ center: location, zoom: 19 });

  useEffect(() => {
    setCamera((previous) => ({ ...previous, center: location }));
  }, [location.lat, location.lng]);

  const handleMapClick = (event: MapMouseEvent) => {
    if (!displayOnly && event.detail.latLng) {
      const newCameras = [
        ...values.cameras,
        {
          locationDescription: "",
          FOVDescription: "",
          Make: "",
          Model: "",
          geometry: event.detail.latLng,
        },
      ];
      setFieldValue("cameras", newCameras);
    }
  };

  return apiIsLoaded ? (
    <>
      {errors.cameras && typeof errors.cameras === "string" && (
        <Typography sx={{ color: "red" }}>{errors.cameras}</Typography>
      )}
      <Map
        colorScheme={mapColorScheme}
        center={camera.center}
        zoom={camera.zoom}
        onCameraChanged={(event: MapCameraChangedEvent) =>
          setCamera({
            center: event.detail.center,
            zoom: event.detail.zoom,
          })
        }
        style={{ height: "412px", width: "100%" }}
        onClick={handleMapClick}
        streetViewControl={false}
        mapTypeId="satellite"
        zoomControl
        draggable={false}
        scrollwheel
        maxZoom={22}
        minZoom={17}
        tilt={0}
      >
        {values.cameras.map((camera, index) => (
          <Marker
            key={index}
            position={camera.geometry}
            label={{
              text: (index + 1).toString(),
              color: colors.common.white,
            }}
          />
        ))}
      </Map>
    </>
  ) : (
    <div>Loading...</div>
  );
};

export default PropertyCamerasMap;
